import { render, staticRenderFns } from "./SfAddress.vue?vue&type=template&id=28bee919"
import script from "./SfAddress.vue?vue&type=script&lang=js"
export * from "./SfAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports